import React from 'react';
import { node, bool } from 'prop-types';
import styled from 'styled-components';
import { useStaticQuery, graphql } from 'gatsby';
import { breakpoints, headerHeight } from 'TMConstants';

const StyledMain = styled.main`
    overflow-x: hidden;
    ${({ whiteBackground }) =>
        whiteBackground && `background-color: #FFFFFF;`}
`;
// workaround for internet explorer as padding in main seems to be ignored, change to margin made it chrome to auto scroll to header component
const TopMargin = styled.div`
    width: 100%;
    /* istanbul ignore next */
    ${(props) => `
        height: ${
            headerHeight.mobile +
            (props.hasBanner && 72) +
            (props.hasCrumbs && (props.reducedCrumbSpacing ? 72 : 84 + 75))
        }px;
    @media(min-width: ${breakpoints.mobileTablet}px){
        height: ${
            headerHeight.desktop +
            (props.hasBanner && 50) +
            (props.hasCrumbs && (props.reducedCrumbSpacing ? 96 : 84 + 50))
        }px;
    }`}
`;

const Main = ({
    isBannerAllowed,
    isCrumbsAllowed,
    reducedCrumbSpacing,
    whiteBackground,
    children
}) => {
    const { banner } = useStaticQuery(graphql`
        {
            banner: datoCmsSiteBanner {
                showBanner
            }
        }
    `);

    return (
        <StyledMain
            whiteBackground={whiteBackground || reducedCrumbSpacing}>
            <TopMargin
                hasBanner={isBannerAllowed && banner.showBanner}
                hasCrumbs={isCrumbsAllowed}
                reducedCrumbSpacing={reducedCrumbSpacing}
            />
            {children}
        </StyledMain>
    );
};

Main.propTypes = {
    children: node.isRequired,
    isBannerAllowed: bool,
    isCrumbsAllowed: bool,
    reducedCrumbSpacing: bool,
    whiteBackground: bool
};

Main.defaultProps = {
    isCrumbsAllowed: false,
    isBannerAllowed: false,
    reducedCrumbSpacing: false,
    whiteBackground: false
};

export default Main;
